// Generated by Melange

import EnJson from "./resources/translations/en.json";
import Landing_enJson from "./resources/translations/landing_en.json";
import Landing_kkJson from "./resources/translations/landing_kk.json";
import Landing_ruJson from "./resources/translations/landing_ru.json";
import Landing_uzJson from "./resources/translations/landing_uz.json";
import RuJson from "./resources/translations/ru.json";
import * as Curry from "melange.js/curry.js";
import * as React from "react";

const en = EnJson;

const ru = RuJson;

const kk = "kk";

const uz = "uz";

const landing_en = Landing_enJson;

const landing_kk = Landing_kkJson;

const landing_ru = Landing_ruJson;

const landing_uz = Landing_uzJson;

const all = [
  /* En */ 0,
  /* Ru */ 1,
  /* Kk */ 2,
  /* Uz */ 3
];

function toString(param) {
  switch (param) {
    case /* En */ 0 :
      return "en";
    case /* Ru */ 1 :
      return "ru";
    case /* Kk */ 2 :
      return "kk";
    case /* Uz */ 3 :
      return "uz";
  }
}

function fromString(param) {
  switch (param) {
    case "en" :
      return /* En */ 0;
    case "kk" :
      return /* Kk */ 2;
    case "uz" :
      return /* Uz */ 3;
    default:
      return /* Ru */ 1;
  }
}

function translations(param) {
  switch (param) {
    case /* En */ 0 :
      return en;
    case /* Ru */ 1 :
      return ru;
    case /* Kk */ 2 :
      return kk;
    case /* Uz */ 3 :
      return uz;
  }
}

function landingTranslations(param) {
  switch (param) {
    case /* En */ 0 :
      return landing_en;
    case /* Ru */ 1 :
      return landing_ru;
    case /* Kk */ 2 :
      return landing_kk;
    case /* Uz */ 3 :
      return landing_uz;
  }
}

function useLocale(initialLocale) {
  const match = React.useState(function () {
    return initialLocale;
  });
  const setLocale = match[1];
  const setLocale$1 = function (locale) {
    Curry._1(setLocale, (function (param) {
      return locale;
    }));
  };
  return [
    match[0],
    setLocale$1
  ];
}

function toCountryString(country) {
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */ 0 :
      return "–";
    case /* COUNTRY_KAZ */ 1 :
      return "kz";
    case /* COUNTRY_KGZ */ 2 :
      return "kg";
    case /* COUNTRY_UZB */ 3 :
      return "uz";
  }
}

function toCountryEnum(country) {
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */ 0 :
    case /* COUNTRY_KAZ */ 1 :
      return "kz";
    case /* COUNTRY_KGZ */ 2 :
      return "kg";
    case /* COUNTRY_UZB */ 3 :
      return "uz";
  }
}

function toCountry(countryStr) {
  switch (countryStr) {
    case "kg" :
      return /* COUNTRY_KGZ */ 2;
    case "uz" :
      return /* COUNTRY_UZB */ 3;
    default:
      return /* COUNTRY_KAZ */ 1;
  }
}

function getPhonePrefix(country) {
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */ 0 :
    case /* COUNTRY_KAZ */ 1 :
      return "+7";
    case /* COUNTRY_KGZ */ 2 :
      return "+996";
    case /* COUNTRY_UZB */ 3 :
      return "+998";
  }
}

function getPhonePrefixLength(country) {
  return getPhonePrefix(country).length;
}

function getPhoneSuffixLength(country) {
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */ 0 :
    case /* COUNTRY_KAZ */ 1 :
      return 10;
    case /* COUNTRY_KGZ */ 2 :
    case /* COUNTRY_UZB */ 3 :
      return 9;
  }
}

function getCountryLocale(country, language) {
  switch (country) {
    case /* COUNTRY_UNSPECIFIED */ 0 :
      switch (language) {
        case /* En */ 0 :
          return "Kazakhstan";
        case /* Ru */ 1 :
          return "Казахстан";
        case /* Kk */ 2 :
          return "Қазақстан";
        case /* Uz */ 3 :
          return "Qozog'iston";
      }
    case /* COUNTRY_KAZ */ 1 :
      switch (language) {
        case /* En */ 0 :
          return "Kazakhstan";
        case /* Ru */ 1 :
          return "Казахстан";
        case /* Kk */ 2 :
          return "Қазақстан";
        case /* Uz */ 3 :
          return "Qozog'iston";
      }
    case /* COUNTRY_KGZ */ 2 :
      switch (language) {
        case /* En */ 0 :
          return "Kyrgyzstan";
        case /* Ru */ 1 :
          return "Кыргызстан";
        case /* Kk */ 2 :
          return "Қырғызстан";
        case /* Uz */ 3 :
          return "Qirg'iziston";
      }
    case /* COUNTRY_UZB */ 3 :
      switch (language) {
        case /* En */ 0 :
          return "Uzbekistan";
        case /* Ru */ 1 :
          return "Узбекистан";
        case /* Kk */ 2 :
          return "Өзбекстан";
        case /* Uz */ 3 :
          return "Uzbekiston";
      }
  }
}

export {
  en,
  ru,
  kk,
  uz,
  landing_en,
  landing_kk,
  landing_ru,
  landing_uz,
  all,
  toString,
  fromString,
  translations,
  landingTranslations,
  useLocale,
  toCountryString,
  toCountryEnum,
  toCountry,
  getPhonePrefix,
  getPhonePrefixLength,
  getPhoneSuffixLength,
  getCountryLocale,
}
/* en Not a pure module */
